var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ThemeProvider as Provider } from 'styled-components';
import merge from 'lodash.merge';
import defaultVariables from './theme/default';
import defaultComponentsThemeFn from './theme/default/components';
var ThemeProvider = /** @class */ (function (_super) {
    __extends(ThemeProvider, _super);
    function ThemeProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeProvider.prototype.render = function () {
        var _a = this.props, theme = _a.theme, componentTheme = _a.componentTheme, children = _a.children;
        var combinedTheme = defaultVariables;
        if (theme && Object.keys(theme).length > 0) {
            combinedTheme = combineTheme(defaultVariables, theme);
        }
        var combinedWithComponentTheme = combinedWithComponent(combinedTheme, componentTheme);
        return (React.createElement(Provider, { theme: combinedWithComponentTheme }, children));
    };
    ThemeProvider.defaultProps = {
        theme: {},
    };
    return ThemeProvider;
}(React.Component));
export default ThemeProvider;
export function combineTheme(varirables, theme) {
    return __assign({}, varirables, theme);
}
export function combinedWithComponent(theme, componentTheme) {
    return merge(theme, defaultComponentsThemeFn(theme), componentTheme && componentTheme(theme));
}
//# sourceMappingURL=ThemeProvider.js.map